(function () {
  'use strict';

  angular
    .module('vcfinance.unicat')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcfinanceunicat', {
        url: '/financeunicat',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;unicateditor unicat=""&gt;</tt></h3><div ui-view="unicateditview"></div>
              <h3 class="alert alert-info"><tt>&lt;unicatlist&gt;</tt></h3><div ui-view="unicatlistview"></div>
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.vcfinanceunicat entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcfinanceunicat.allcomponents', {
        url: '/allcomponents',
        resolve: {

        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve

          'unicateditview@playground.vcfinanceunicat': {
            component: 'unicateditor',
            bindings: {
              unicat: 'someunicat'
            }
          },
          'unicatlistview@playground.vcfinanceunicat': {
            component: 'unicatlist',
            bindings: {
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcfinanceunicat.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






